<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'HeaderBtnSonProfilOuConnexion'
});
</script>
<template>
  <ka-container
    code="header-btn-son-profil-ou-connexion"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-button
      code="connexion"
      :options="{
        ripple: true,
        href: { name: `Connexion` },
        click: componentInstance.connexionClick,
        hidden: componentInstance.$isLogged.value === false ? false : null
      }">
      <span v-html="t('headerBtnSonProfilOuConnexion.connexion.value', `Connexion`)" />
    </ka-button>
    <!-- Container -->
    <ka-container
      code="container"
      :xs="{ click: componentInstance.containerClickOnXs }">
      <!-- Container -->
      <ka-container
        code="container-1"
        :options="{
          click: componentInstance.container1Click,
          $state: { selected: $isEqual(componentInstance.$elements['container-2']?.style.hidden, componentInstance.$constants.containerHidden) },
          hidden: componentInstance.$isLogged.value === true ? false : null
        }"
        :selected="{ click: componentInstance.container1ClickWhenSelected }">
        <ka-image
          code="image"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            hidden: componentInstance.$urlImage.value == null || componentInstance.$urlImage.value === '' ? null : false,
            imgFit: `cover`
          }"
          :value="componentInstance.$urlImage.value" />
        <ka-icon
          code="icon"
          :options="{ hidden: componentInstance.$urlImage.value == null || componentInstance.$urlImage.value === '' ? false : null }"
          value="i-fa-solid:user" />
      </ka-container>
    </ka-container>
    <!-- Container -->
    <ka-container
      code="container-2"
      :options="{ hidden: null }">
      <ka-text
        code="profil"
        :options="{
          href: { name: `Connexion` },
          click: componentInstance.profilClick,
          $state: { selected: $isEqual(componentInstance.$elements['container-2']?.style.hidden, componentInstance.$constants.containerHidden2) }
        }">
        <span v-html="t('headerBtnSonProfilOuConnexion.container2.profil.value', `Profil`)" />
      </ka-text>
      <ka-text
        code="text-1"
        :options="{
          click: componentInstance.text1Click,
          $state: { selected: $isEqual(componentInstance.$elements['container-2']?.style.hidden, componentInstance.$constants.containerHidden2) }
        }">
        <span v-html="t('headerBtnSonProfilOuConnexion.container2.text1.value', `Déconnexion`)" />
      </ka-text>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { headerBtnSonProfilOuConnexionComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c2')
const component = headerBtnSonProfilOuConnexionComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  isLogged?: Nullable<boolean>
  urlImage?: Nullable<string>
  dropDown?: Nullable<boolean>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  isLogged: true,
  urlImage: undefined,
  dropDown: true,
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:isLogged',
  'update:urlImage',
  'update:dropDown'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    isLogged: true,
    urlImage: true,
    dropDown: true
  }
})
</script>
